import React, { useState } from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'
import LazyImage from '../LazyImage'

import { getSomeStories } from '../../data/stories'

export default function StoriesCard (props) {
  const [storiesPosts, setStoriesPosts] = useState(props.storiesPosts.json)
  const [currentPage, setPage] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const [slideUpRef, isInView] = useInView({ triggerOnce: true })

  const pages = [...Array(props.storiesPosts.maxPages).keys()]

  const getMoreStoriesPosts = async pageNumber => {
    if (isLoading) return
    setIsLoading(true)
    setPage(pageNumber - 1)
    const newPosts = await getSomeStories(pageNumber)
    await setStoriesPosts(newPosts.json)
    setIsLoading(false)
  }

  const renderPagination = () => (
    <React.Fragment>
      <div className='pagination spacer'>
        <div
          className='d-flex justify-content-left page-numbers'
          style={{ paddingTop: 10 }}
        >
          {/*<img alt='Previous' src='/left.svg' height='18' width='18' />*/}
          {pages.map(pageNo =>
            pageNo === currentPage ? (
              <span
                key={pageNo}
                aria-current='page'
                className='page-numbers current'
              >
                {pageNo + 1}
              </span>
            ) : (
              <a
                key={pageNo}
                className='page-numbers'
                style={{ cursor: 'pointer' }}
                scroll='false'
                onClick={() => getMoreStoriesPosts(pageNo + 1)}
              >
                {pageNo + 1}
              </a>
            )
          )}
        </div>
      </div>
      <style jsx>{`
        .pagination {
          position: relative;
        }
      `}</style>
    </React.Fragment>
  )

  const divStyle = src => ({
    backgroundImage: 'url(' + src + ')'
  })

  const renderStories = items =>
    items.map(data => {
      if (props.events) {
        if (data.event_image.url) {
          var bgImage = data.event_image.url
        } else {
          var bgImage = '/public-next/images/quell-placeholder.png'
        }
      } else {
        if (data._embedded['wp:featuredmedia']) {
          var bgImage = data._embedded['wp:featuredmedia'][0].source_url
        } else {
          var bgImage = '/public-next/images/quell-placeholder.png'
        }
      }

      return (
        //if no props.events then display this
        <div
          key={data.id}
          className={` animation col-12 col-lg-6 link-column ${
            isInView ? 'slide-up' : ''
          }`}
        >
          {bgImage ? (
            <LazyImage background imageClass='link-column__image' src={bgImage}>
              <div className='image__caption col-10'>
                <h2
                  className='image-caption'
                  dangerouslySetInnerHTML={{ __html: data.title.rendered }}
                  id={`article-${data.id}`}
                />
              </div>
            </LazyImage>
          ) : (
            <div className='image__caption col-10'>
              <h2
                className='image-caption'
                dangerouslySetInnerHTML={{ __html: data.title.rendered }}
                id={`article-${data.id}`}
              />
            </div>
          )}

          <div className='link-column__text'>
            {data.secondaryTitle ? (
              <h3 className='event-name'>{secondaryTitle}</h3>
            ) : (
              ''
            )}
            {data.body ? (
              <p
                className='event-description'
                dangerouslySetInnerHTML={{ __html: body }}
              />
            ) : (
              ''
            )}
            <div>
              <Link
                as={`/stories/${data.slug}`}
                href='/stories/[slug]'
                passHref
              >
                <a
                  target='_blank'
                  className='link'
                >
                  Read
                  <span 
                    className='sr-only'
                    dangerouslySetInnerHTML={{ __html: data.title.rendered }}
                  />
                </a>
              </Link>
            </div>
          </div>
        </div>
      )
    })

  return (
    <React.Fragment>
      <span id='skip'></span>
      <div ref={slideUpRef} className='container-fluid link-columns mt-200'>
        <div
          className='row'
          style={{ opacity: isLoading ? 0.5 : 1, transition: 'opacity 0.25s' }}
        >
          {renderStories(storiesPosts)}
        </div>
        <div className='col-12'>{renderPagination()}</div>
      </div>
    </React.Fragment>
  )
}
